import NButtonModel from '@/uikit/buttons/NButtonModel.vue';
import NSwitch from '@/uikit/switch/NSwitch.vue';
import { ITableColumn } from '@/uikit/table/NTable.vue';
import NTableColumnCell from '@/uikit/table/NTableColumnCell.vue';
import ButtonModelCopy from '@/components/common/ButtonModelCopy.vue';

const columns: ITableColumn[] = [
  {
    width: 'max-content',
    header: {
      classes: ['bottom-border'],
      component: NTableColumnCell,
      props: {
        name: 'id',
        i18n_label: 'common.id',
        sortable: true
      }
    },
    content: {
      path: 'id',
      component: ButtonModelCopy
    }
  },
  {
    header: {
      classes: ['bottom-border'],
      component: NTableColumnCell,
      props: {
        i18n_label: 'common.column_name',
        name: 'name',
        sortable: true
      }
    },
    content: {
      path: 'name',
      component: NButtonModel,
      props: { type: 'link', align: 'left' }
    }
  },
  {
    width: '100px',
    header: {
      classes: ['align-right', 'bottom-border'],
      component: NTableColumnCell,
      props: {
        i18n_label: 'common.column_active',
        name: 'active',
        sortable: true
      }
    },
    content: {
      path: 'active',
      classes: ['align-right'],
      component: NSwitch
    }
  }
];

export default columns;
